import { object, string } from "yup";
import { DOC_TYPE_ERROR_MESSAGE } from "./constants";

export const documentValidations = object({
  type: string().required(DOC_TYPE_ERROR_MESSAGE)
});
